import { ModalService } from './../../../../base/shared/modal/modal.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { VendorScoreCardVendorsService } from './vendor-score-card-vendors.service';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { CommandClickEventArgs, CommandModel, EditService, FilterService, GridModule, PageService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DataManager } from '@syncfusion/ej2-data';
import { ToolbarClickEventArgs } from '@syncfusion/ej2-angular-filemanager';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { vendorScoreCardVendorsRoute } from 'src/app/core/routing/route-names';
import { CreateVendorScoreCardDTO, IVendorScoreCardOverviewDTO, VendorScoreCardState } from 'src/app/base/models/models.swagger.generated';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { VendorScoreCardAddVendorFormType } from './vendor-score-card-add-vendor-form-type';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-vendor-score-card-vendors',
    templateUrl: './vendor-score-card-vendors.component.html',
    styleUrls: ['./vendor-score-card-vendors.component.scss'],
    imports: [TitleBarComponent, TranslateModule, GridModule, CheckBoxModule, AppErrorMessagesComponent,
        ToolbarModule, TitleBarComponent, DialogModule, DropDownListModule, ReactiveFormsModule],
    providers: [PageService, FilterService, ToolbarService, SortService, EditService]
})

export class VendorScoreCardVendorsComponent extends GridBaseComponent<any> implements OnInit, AfterViewInit {
  @ViewChild('dialog') dialog: DialogComponent | any;

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public customEditSettings = {
    allowEditing: false,
    allowAdding: true,
    allowDeleting: true,
    mode: 'Dialog',
    showDeleteConfirmDialog: true
  };

  public toolbarOptions = ['Add', 'Delete'];

  public dialogObj: any;
  public languages: Array<string> = ["EN", "DE"];
  public selectedLanguage: string = this.languages[0];

  public checkBoxFilter = GridConstantsFactory.createCheckBoxFilter();

  public form: FormGroup<VendorScoreCardAddVendorFormType>;

  public fields: Object = { text: 'name', value: 'id' };

  public override gridCommands = [
    {
      type: 'None',
      title: 'Show Details',
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'e-table e-icons'
      }
    },
    {
      type: 'None',
      title: 'Resend Email',
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-mail--all e-icons'
      }
    }
  ] as CommandModel[];

  constructor(
    private vendorScoreCardVendorsService: VendorScoreCardVendorsService,
    translateService: TranslateService,
    private router: Router,
    private spinnerService: SpinnerService,
    private fb: FormBuilder,
    private modalService: ModalService
  ) {
    super(translateService, vendorScoreCardVendorsService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.vendorScoreCardVendorsService, this.spinnerService),
    });

    this.isActiveColumnName = 'active';

    this.initializeForm();
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
          if(args.target.tagName === 'BODY') {
              this.dialog!.hide();
          }
      }
  }

  public onRowDataBound(args: any) {
    const dto = args.data as IVendorScoreCardOverviewDTO;
    if (this.isSurveyCompleted(dto.state)) {
      var button = args.row.cells[args.row.cells.length - 1].getElementsByClassName('icon-mail--all');
      if (button && button.length > 0 && button[0].parentElement) {
        button[0].parentElement.hidden = true;
      }
    }
    else {
      var button = args.row.cells[args.row.cells.length - 1].getElementsByClassName('e-table');
      if (button && button.length > 0 && button[0].parentElement) {
        button[0].parentElement.hidden = true;
      }
    }
  }

  public getStateName(state: VendorScoreCardState): string {
    return "i18n.shared.VendorScoreCardState." + VendorScoreCardState[state];
  }

  public toolbarClickHandler(args: ToolbarClickEventArgs): void {
    if(args.item.id.includes("add"))
    {
      args.cancel = true;
      this.dialog.show();
    }
  }

  public addVendor() {
    if(!this.form.valid) {
      return;
    }
    var newVendor = new CreateVendorScoreCardDTO(
      {
        vendorName: this.form.value.vendorName,
        email: this.form.value.email,
        language: this.selectedLanguage
      }
    );
    this.vendorScoreCardVendorsService.addRecord(newVendor).subscribe({
      complete: () => {
        this.grid.refresh();
      }
    });
    this.dialog.hide();
  }

  public isSurveyCompleted(state: VendorScoreCardState) {
    return state == VendorScoreCardState.Complete;
  }

  public commandClick(args: CommandClickEventArgs) {
    const dto = args.rowData as IVendorScoreCardOverviewDTO;
    if(this.isSurveyCompleted(dto.state)) {
      this.router.navigate([vendorScoreCardVendorsRoute, dto.id]);
    } else {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.vendor-score-card.messages.email-resend-dialog-title', 'i18n.domain.vendor-score-card.messages.email-resend-dialog-message');
      dialog.onOkSubject.subscribe(() => {
        this.vendorScoreCardVendorsService.resendEmail(dto.id).subscribe();
      });

    }
  }

  private initializeForm(): void {
    this.form = this.fb.group<VendorScoreCardAddVendorFormType>({
      vendorName: this.fb.control(null, [Validators.required]),
      email: this.fb.control(null, [Validators.required]),
    });
  }
}
